import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AccessControl from '../../../../AccessControl';
import Error404 from '../../../../Error404';
import { PERMISSIONS_KEY, ROUTES } from '../../../../common/constants';
import PlayPlanTabs from './components/PlayPlanTabs';

const PlayPlanWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES?.SUBSCRIPTION_PLANS}${ROUTES?.PLAY_PLANS}`}
      render={() => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.SUBSCRIPTION_PLANS}>
          <Redirect
            to={`${ROUTES?.SUBSCRIPTION_PLANS}${ROUTES?.PLAY_PLANS}${ROUTES?.PLAY_MAX_ANNUALLY}`}
          />
        </AccessControl>
      )}
    />

    <Route
      exact
      path={`${ROUTES?.SUBSCRIPTION_PLANS}${ROUTES?.PLAY_PLANS}/*`}
      render={() => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.SUBSCRIPTION_PLANS}>
          <PlayPlanTabs />
        </AccessControl>
      )}
    />
    <Route path="*" exact component={Error404} />
  </Switch>
);

export default PlayPlanWrapper;
